const colorTypeOptionsRanking = [
	'#C11F39',
	'#C11F39',
	'#C11F39',
	'#C11F39',
	'#C11F39',
	'#C11F39',
	'#C11F39',
	'#C11F39',
	'#C11F39',
	'#C11F39',
]

function convertUnderscoreToNumber(value) {
	if (typeof value === 'string') {
		return parseFloat(value.replace(/_/g, ''))
	} else if (typeof value === 'number') {
		return value
	}
	return 0
}

export default {
	name: 'GraficoFundacoesSapRanking',
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		processDataValues(data) {
			return data
				.map((item) => {
					const valorCaptacao =
						typeof item.valor_captacao === 'string'
							? Number(item.valor_captacao)
							: item.valor_captacao
					return {
						...item,
						x: item.nome_cliente_pf || 'Desconhecido',
						y: valorCaptacao,
						total: valorCaptacao,
					}
				})
				.sort((a, b) => {
					return a.y - b.y
				})
		},
	},

	watch: {
		data() {
			if (this.chartInstance) {
				this.chartInstance.updateSeries([
					{
						name: '',
						data: this.processDataValues(this.data),
					},
				])
			}
		},
	},

	data() {
		return {
			chartInstance: null,
			optionsFundacoesRanking: {
				series: [
					{
						name: '',
						data: this.processDataValues(this.data),
					},
				],
				chart: {
					type: 'bar',
					height: 350,
				},
				title: {
					text: 'Top/Bottom SAP',
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '60%',
						dataLabels: {
							position: 'top',
							maxItems: 100,
							hideOverflowingLabels: false,
							orientation: 'horizontal',
						},
					},
				},
				colors: colorTypeOptionsRanking, // todas as barras vermelhas
				dataLabels: {
					enabled: true,
					textAnchor: 'middle',
					distributed: false,
					offsetY: -20,
					style: {
						fontSize: '12px',
						fontWeight: 600,
						colors: ['#373D3F'],
					},
					formatter: function (val, opts) {
						const dataPoint =
							opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
						const absoluteValue = Math.abs(dataPoint.total || val)

						return GLOBAL.FMoneyK(val || dataPoint.total)
					},
					dropShadow: {
						enabled: false,
					},
				},
				tooltip: {
					y: {
						formatter: function (val, opts) {
							const data =
								opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
							return `Cliente: ${data.x}<br>Captação: ${data.y.toLocaleString(
								'pt-BR',
								{
									style: 'currency',
									currency: 'BRL',
									maximumFractionDigits: 2,
								}
							)}`
						},
					},
				},
				xaxis: {},
				yaxis: {
					labels: {
						formatter: function (val) {
							return val.toLocaleString('pt-BR', {
								style: 'currency',
								currency: 'BRL',
								maximumFractionDigits: 2,
							})
						},
					},
				},
			},
		}
	},
	mounted() {
		const el = document.querySelector('#chart_fundacoes_sap_ranking')
		if (!el) {
			console.error('Elemento #chart_fundacoes_sap_ranking não encontrado!')
			return
		}

		this.chartInstance = new ApexCharts(el, this.optionsFundacoesRanking)
		this.chartInstance.render()
	},
	beforeUnmount() {
		if (this.chartInstance) {
			this.chartInstance.destroy()
		}
	},
	template: `
        <div id="chart_fundacoes_sap_ranking"></div>
    `,
}
